(ns frontend.ux-overhaul.listing.transaction-process.event
  (:require [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [re-frame.core :as rf]
            [reagent.core :as r]))

;; transaction-process has its own fund/template-selection creation modal
;; (ui.view.transaction-process.create-modal), not a generic
;; frontend.view.entity/open-creator! flow - the legacy grid drives it with a
;; plain local atom (frontend.view.grid.transaction-processes-grid.db/modal-state),
;; so this listing reuses that same pattern rather than routing the toolbar
;; action's dispatch through app-db.
(defonce create-modal-open? (r/atom false))

(rf/reg-event-fx
 ::open-create-transaction-process-modal
 (fn [_ _]
   (reset! create-modal-open? true)
   {}))

(defn close-create-modal!
  []
  (reset! create-modal-open? false))

(rf/reg-event-fx
 ::bulk-delete-selected
 (fn [{:keys [db]} [_ {:keys [listing-id]}]]
   ;; transaction-process has its own dedicated soft-delete endpoint
   ;; (:transaction-process/mass-delete, not the :<entity>/mass-action shape
   ;; every other entity uses) - no :action key, just the ids.
   (bulk-actions/bulk-delete-selected!
    {:db        db
     :listing-id listing-id
     :operation :transaction-process/mass-delete
     :body-fn   (fn [ids]
                  {:transaction-process-ids ids})})
   {}))
